import importer from 'common/importer'
const { deloitReq: req } = importer('APIs', null)

/**
 * Login with proxy- Heroku
 * @param {Object} param0
 * @param {String} param0.token
 * @param {String} proxyPdn
 */
const loginWithProxyPdn= ({ token,proxyPdn }) => {
    return req.get('/users/login', {
      headers: {
        Authorization: token,
        proxyPdn:proxyPdn
      }
    })
  }

  export default loginWithProxyPdn